// === nyn Fiyat TR v3.0 — attribute-based ===
// NOT: nynMkSelect + DOMContentLoaded handler artık SADECE snippets/nyn-miktar-kirimi.liquid
// içindeki inline <script> bloğunda yer alıyor. Burada duplikasyon kaldırıldı (race condition fix).
(function(){
  var F0=new Intl.NumberFormat('tr-TR',{maximumFractionDigits:0,minimumFractionDigits:0});
  var F2=new Intl.NumberFormat('tr-TR',{maximumFractionDigits:2,minimumFractionDigits:0});
  function tl(c){return F0.format(c/100)+' ₺';}
  function fix(){
    document.querySelectorAll('.nyn-mk-opt').forEach(function(o){
      var c=parseInt(o.getAttribute('data-price')||'0',10);
      if(!c)return;

      // Main price — from data-price (cents)
      var pe=o.querySelector('.nyn-mk-price');
      if(pe)pe.textContent=tl(c);

      // Per-kg — calculate from data-price + qty text
      var qe=o.querySelector('.nyn-mk-qty');
      var ke=o.querySelector('.nyn-mk-per-pill');
      if(ke&&qe){
        var kg=parseFloat(qe.textContent)||1;
        ke.textContent=F2.format(c/100/kg)+' ₺/kg';
      }

      // Compare-at — from data-compare-price (cents)
      var cp=parseInt(o.getAttribute('data-compare-price')||'0',10);
      var oe=o.querySelector('.nyn-mk-old');
      if(oe&&cp>0)oe.textContent=tl(cp);

      // Saving badge — from data-saving (cents)
      var sv=parseInt(o.getAttribute('data-saving')||'0',10);
      var se=o.querySelector('[class*="saving"],[class*="kazanc"]');
      if(se&&sv>0){
        var st=se.textContent;
        se.textContent=st.replace(/[d,. ]+s*TL/,F0.format(sv/100)+' ₺');
      }
    });

    // ATC button price
    var ap=document.getElementById('atcPrice');
    if(ap){
      var ac=document.querySelector('.nyn-mk-opt.active');
      if(ac){var v=parseInt(ac.getAttribute('data-price')||'0',10);if(v)ap.textContent='— '+tl(v);}
    }
  }

  ['DOMContentLoaded','load'].forEach(function(e){document.addEventListener(e,fix);});
  setTimeout(fix,0);setTimeout(fix,200);setTimeout(fix,600);
  document.addEventListener('click',function(e){if(e.target.closest('.nyn-mk-opt'))setTimeout(fix,20);});
})();
